/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";
import "owl.carousel2.thumbs/dist/owl.carousel2.thumbs.min.js";
import "@fancyapps/fancybox/dist/jquery.fancybox.min.js";
import Splide from "@splidejs/splide";
import DataLayerEvent from "./gtm/DataLayerEvent.js";

import "summernote";

import "./components/component-forms.js";
import "bootstrap-datepicker";
import "bootstrap-datepicker/js/locales/bootstrap-datepicker.nl";
import VueAxios from "vue-axios";
import Vue from "vue";
import GTagLoader from "./gtm/GTagLoader.js";

require("./bootstrap");

window.Splide = Splide;
window.axios = require("axios");
window.Vue = Vue;
Vue.use(VueAxios, axios);

$(document).ready(function () {
    // $.ajaxSetup({
    //     headers: {
    //         'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    //     }
    // });
});

window.axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
};

require("./frontend/cache.js");
require("./frontend/form.js");
require("./frontend/header.js");
require("./frontend/carousel.js");
require("./frontend/fancybox.js");
require("./frontend/product.js");
require("./frontend/splide.js");
require("./utils/global-shopping-cart.js");
require("./vue/shopping-cart");
require("./vue/checkout");

window.storeContainerIds = {
    1: {
        gtm: "GTM-MQ58B4D",
        tiktok: "CFHMEMJC77U110MKCUF0",
    },
    2: {
        gtm: "GTM-W3HB9CCK",
        tiktok: false,
    },
};

window.debug = false;
window.log = function (...message) {
    if (window.debug) {
        console.log(...message);
    }
};

$("#list").click(function () {
    $(".product-grid.main-products .product").addClass("list-grid");
    $("#list").addClass("active");
    $("#grid").removeClass("active");
});

$("#grid").click(function () {
    $(".product-grid.main-products .product").removeClass("list-grid");
    $("#list").removeClass("active");
    $("#grid").addClass("active");
});

$(document).ready(function () {
    // if('ontouchstart' in window || navigator.msMaxTouchPoints) {
    //     $('.nav-meta.mobile')[0].style.setProperty("display", "block", "important");
    //     $('.nav-meta.desktop')[0].style.setProperty("display", "none", "important");
    //     $('.mega-menu').hide();
    // }

    $("body").css("padding-top", $("#header").height());

    if ($(".homepage__categories h4")) {
        let heighest_block = 0;
        $(".homepage__categories h4").each(function () {
            if ($(this).height() > heighest_block) {
                heighest_block = $(this).height();
            }
        });

        $(".homepage__categories h4").css("height", heighest_block);
    }

    $(".nav-toggler").on("click", function () {
        $(".mobile-sidebar").toggleClass("show");
        $("html, body").addClass("no-scroll");
    });

    $(".mobile-sidebar-close").on("click", function () {
        $(".mobile-sidebar").removeClass("show");
        $("html, body").removeClass("no-scroll");
        $(".nav-toggler").removeClass("open");
    });

    $(".nav-toggler").on("click", function () {
        $(this).toggleClass("open");
    });

    $(".mobile-filter-toggle").on("click", function () {
        $(".mobile-filter, .mobile-filter-overlay").toggleClass("show");
        $("html, body").addClass("no-scroll");
    });

    $(".mobile-filter-close").on("click", function () {
        $(".mobile-filter").removeClass("show");
        $("html, body").removeClass("no-scroll");
    });

    $(".mobile-filter-overlay").on("click", function () {
        $(this).removeClass("show");
        $(".mobile-filter").removeClass("show");
        $("html, body").removeClass("no-scroll");
    });

    var heighest_block = 0;
    // $('.sub-page').css('height', 'auto');
    // $('.sub-page').each(function () {
    //     if ($(this).innerHeight() > heighest_block) {
    //     heighest_block = $(this).innerHeight();
    //     }
    // });

    // $('.sub-page').css('height', heighest_block);

    // if($('.product-categories')){
    //     var heighest_category = 0;
    //     const mindes = 362;
    //     const minmob = 335;
    //     $('.product-categories .card').css('height', 'auto');
    //     $('.product-categories .card').each(function () {
    //         if ($(this).innerHeight() > heighest_category) {
    //             heighest_category = $(this).innerHeight();
    //         }
    //     });
    //     $('.product-categories .card').css('height', heighest_category);
    // }

    // if($('.search-category-grid')){
    //     var heighest_category = 0;
    //     $('.search-category-grid .card').css('height', 'auto');
    //     $('.search-category-grid .card').each(function () {
    //         if ($(this).innerHeight() > heighest_category) {
    //             heighest_category = $(this).innerHeight();
    //         }
    //     });
    //     $('.search-category-grid .card').css('height', heighest_category);
    // }

    function closeMenu() {
        $(".mobile-sidebar").removeClass("show");
        $(".nav-toggler").removeClass("open");

        if (!$(".mobile-filter").hasClass("show")) {
            $("html, body").removeClass("no-scroll");
        }
    }

    $(".mobile-sidebar ul li ul li a").on("click", function () {
        $(this).parent().find("ul.subsubmenu").addClass("show");
        $(".mobile-sidebar").addClass("subsubopen");
        $(".mobile-sidebar").scrollTop(0);
    });

    $(".mobile-sidebar ul li ul li ul li.back").on("click", function () {
        $(this).parent("ul.subsubmenu").removeClass("show");
        $(".mobile-sidebar").removeClass("subsubopen");
    });

    $(".footer-service, #footer").on("click", function (e) {
        closeMenu();
    });

    $(".nav-toggler, .mobile-filter-toggle").on("click", function (e) {
        e.stopPropagation(); // this stops the event from bubbling up to the body
    });
});

// $(function () {
//     $('.sidebar').StickySidebar({
//         // Settings
//         additionalMarginTop: 260
//     });
// });

(function ($) {
    $.fn.StickySidebar = function (options) {
        var defaults = {
            containerSelector: "",
            additionalMarginTop: 0,
            additionalMarginBottom: 0,
            updateSidebarHeight: true,
            minWidth: 0,
            disableOnResponsiveLayouts: true,
            sidebarBehavior: "modern",
        };
        options = $.extend(defaults, options);

        // Validate options
        options.additionalMarginTop =
            parseInt(options.additionalMarginTop) || 0;
        options.additionalMarginBottom =
            parseInt(options.additionalMarginBottom) || 0;

        tryInitOrHookIntoEvents(options, this);

        // Try doing init, otherwise hook into window.resize and document.scroll and try again then.
        function tryInitOrHookIntoEvents(options, $that) {
            var success = tryInit(options, $that);

            if (!success) {
                // window.log('TST: Body width smaller than options.minWidth. Init is delayed.');

                $(document).scroll(
                    (function (options, $that) {
                        return function (evt) {
                            var success = tryInit(options, $that);

                            if (success) {
                                $(this).unbind(evt);
                            }
                        };
                    })(options, $that)
                );
                $(window).resize(
                    (function (options, $that) {
                        return function (evt) {
                            var success = tryInit(options, $that);

                            if (success) {
                                $(this).unbind(evt);
                            }
                        };
                    })(options, $that)
                );
            }
        }

        // Try doing init if proper conditions are met.
        function tryInit(options, $that) {
            if (options.initialized === true) {
                return true;
            }

            if ($("body").width() < options.minWidth) {
                return false;
            }

            init(options, $that);

            return true;
        }

        // Init the sticky sidebar(s).
        function init(options, $that) {
            options.initialized = true;

            // Add CSS
            $("head").append(
                $(
                    '<style>.StickySidebar:after {content: ""; display: table; clear: both;}</style>'
                )
            );

            $that.each(function () {
                var o = {};

                o.sidebar = $(this);

                // Save options
                o.options = options || {};

                // Get container
                o.container = $(o.options.containerSelector);
                if (o.container.length == 0) {
                    o.container = o.sidebar.parent();
                }

                // Create sticky sidebar
                o.sidebar.parents().css("-webkit-transform", "none"); // Fix for WebKit bug - https://code.google.com/p/chromium/issues/detail?id=20574
                o.sidebar.css({
                    position: "relative",
                    overflow: "visible",
                    // The "box-sizing" must be set to "content-box" because we set a fixed height to this element when the sticky sidebar has a fixed position.
                    "-webkit-box-sizing": "border-box",
                    "-moz-box-sizing": "border-box",
                    "box-sizing": "border-box",
                });

                // Get the sticky sidebar element. If none has been found, then create one.
                o.stickySidebar = o.sidebar.find(".StickySidebar");
                if (o.stickySidebar.length == 0) {
                    o.sidebar.find("script").remove(); // Remove <script> tags, otherwise they will be run again on the next line.
                    o.stickySidebar = $("<div>")
                        .addClass("StickySidebar")
                        .append(o.sidebar.children());
                    o.sidebar.append(o.stickySidebar);
                }

                // Get existing top and bottom margins and paddings
                o.marginTop = parseInt(o.sidebar.css("margin-top"));
                o.marginBottom = parseInt(o.sidebar.css("margin-bottom"));
                o.paddingTop = parseInt(o.sidebar.css("padding-top"));
                o.paddingBottom = parseInt(o.sidebar.css("padding-bottom"));

                // Add a temporary padding rule to check for collapsable margins.
                var collapsedTopHeight = o.stickySidebar.offset().top;
                var collapsedBottomHeight = o.stickySidebar.outerHeight();
                o.stickySidebar.css("padding-top", 1);
                o.stickySidebar.css("padding-bottom", 1);
                collapsedTopHeight -= o.stickySidebar.offset().top;
                collapsedBottomHeight =
                    o.stickySidebar.outerHeight() -
                    collapsedBottomHeight -
                    collapsedTopHeight;
                if (collapsedTopHeight == 0) {
                    o.stickySidebar.css("padding-top", 0);
                    o.stickySidebarPaddingTop = 0;
                } else {
                    o.stickySidebarPaddingTop = 1;
                }

                if (collapsedBottomHeight == 0) {
                    o.stickySidebar.css("padding-bottom", 0);
                    o.stickySidebarPaddingBottom = 0;
                } else {
                    o.stickySidebarPaddingBottom = 1;
                }

                // We use this to know whether the user is scrolling up or down.
                o.previousScrollTop = null;

                // Scroll top (value) when the sidebar has fixed position.
                o.fixedScrollTop = 0;

                // Set sidebar to default values.
                resetSidebar();

                o.onScroll = function (o) {
                    // Stop if the sidebar isn't visible.
                    if (!o.stickySidebar.is(":visible")) {
                        return;
                    }

                    // Stop if the window is too small.
                    if ($("body").width() < o.options.minWidth) {
                        resetSidebar();
                        return;
                    }

                    // Stop if the sidebar width is larger than the container width (e.g. the theme is responsive and the sidebar is now below the content)
                    if (o.options.disableOnResponsiveLayouts) {
                        var sidebarWidth = o.sidebar.outerWidth(
                            o.sidebar.css("float") == "none"
                        );

                        if (sidebarWidth + 50 > o.container.width()) {
                            resetSidebar();
                            return;
                        }
                    }

                    var scrollTop = $(document).scrollTop();
                    var position = "static";

                    // If the user has scrolled down enough for the sidebar to be clipped at the top, then we can consider changing its position.
                    if (
                        scrollTop >=
                        o.container.offset().top +
                            (o.paddingTop +
                                o.marginTop -
                                o.options.additionalMarginTop)
                    ) {
                        // The top and bottom offsets, used in various calculations.
                        var offsetTop =
                            o.paddingTop +
                            o.marginTop +
                            options.additionalMarginTop;
                        var offsetBottom =
                            o.paddingBottom +
                            o.marginBottom +
                            options.additionalMarginBottom;

                        // All top and bottom positions are relative to the window, not to the parent elemnts.
                        var containerTop = o.container.offset().top;
                        var containerBottom =
                            o.container.offset().top +
                            getClearedHeight(o.container);

                        // The top and bottom offsets relative to the window screen top (zero) and bottom (window height).
                        var windowOffsetTop = 0 + options.additionalMarginTop;
                        var windowOffsetBottom;

                        var sidebarSmallerThanWindow =
                            o.stickySidebar.outerHeight() +
                                offsetTop +
                                offsetBottom <
                            $(window).height();
                        if (sidebarSmallerThanWindow) {
                            windowOffsetBottom =
                                windowOffsetTop + o.stickySidebar.outerHeight();
                        } else {
                            windowOffsetBottom =
                                $(window).height() -
                                o.marginBottom -
                                o.paddingBottom -
                                options.additionalMarginBottom;
                        }

                        var staticLimitTop =
                            containerTop -
                            scrollTop +
                            o.paddingTop +
                            o.marginTop;
                        var staticLimitBottom =
                            containerBottom -
                            scrollTop -
                            o.paddingBottom -
                            o.marginBottom;

                        var top = o.stickySidebar.offset().top - scrollTop;
                        var scrollTopDiff = o.previousScrollTop - scrollTop;

                        // If the sidebar position is fixed, then it won't move up or down by itself. So, we manually adjust the top coordinate.
                        if (o.stickySidebar.css("position") == "fixed") {
                            if (o.options.sidebarBehavior == "modern") {
                                top += scrollTopDiff;
                            }
                        }

                        if (o.options.sidebarBehavior == "stick-to-top") {
                            top = options.additionalMarginTop;
                        }

                        if (o.options.sidebarBehavior == "stick-to-bottom") {
                            top =
                                windowOffsetBottom -
                                o.stickySidebar.outerHeight();
                        }

                        if (scrollTopDiff > 0) {
                            // If the user is scrolling up.
                            top = Math.min(top, windowOffsetTop);
                        } else {
                            // If the user is scrolling down.
                            top = Math.max(
                                top,
                                windowOffsetBottom -
                                    o.stickySidebar.outerHeight()
                            );
                        }

                        top = Math.max(top, staticLimitTop);

                        top = Math.min(
                            top,
                            staticLimitBottom - o.stickySidebar.outerHeight()
                        );

                        // If the sidebar is the same height as the container, we won't use fixed positioning.
                        var sidebarSameHeightAsContainer =
                            o.container.height() ==
                            o.stickySidebar.outerHeight();

                        if (
                            !sidebarSameHeightAsContainer &&
                            top == windowOffsetTop
                        ) {
                            position = "fixed";
                        } else if (
                            !sidebarSameHeightAsContainer &&
                            top ==
                                windowOffsetBottom -
                                    o.stickySidebar.outerHeight()
                        ) {
                            position = "fixed";
                        } else if (
                            scrollTop +
                                top -
                                o.sidebar.offset().top -
                                o.paddingTop <=
                            options.additionalMarginTop
                        ) {
                            // Stuck to the top of the page. No special behavior.
                            position = "static";
                        } else {
                            // Stuck to the bottom of the page.
                            position = "absolute";
                        }
                    }

                    /*
                     * Performance notice: It's OK to set these CSS values at each resize/scroll, even if they don't change.
                     * It's way slower to first check if the values have changed.
                     */
                    if (position == "fixed") {
                        o.stickySidebar.css({
                            position: "fixed",
                            width: o.sidebar.width(),
                            top: top,
                            left:
                                o.sidebar.offset().left +
                                parseInt(o.sidebar.css("padding-left")),
                        });
                    } else if (position == "absolute") {
                        var css = {};

                        if (o.stickySidebar.css("position") != "absolute") {
                            css.position = "absolute";
                            css.top =
                                scrollTop +
                                top -
                                o.sidebar.offset().top -
                                o.stickySidebarPaddingTop -
                                o.stickySidebarPaddingBottom;
                        }

                        css.width = o.sidebar.width();
                        css.left = "";

                        o.stickySidebar.css(css);
                    } else if (position == "static") {
                        resetSidebar();
                    }

                    if (position != "static") {
                        if (o.options.updateSidebarHeight == true) {
                            o.sidebar.css({
                                "min-height":
                                    o.stickySidebar.outerHeight() +
                                    o.stickySidebar.offset().top -
                                    o.sidebar.offset().top +
                                    o.paddingBottom,
                            });
                        }
                    }

                    o.previousScrollTop = scrollTop;
                };

                // Initialize the sidebar's position.
                o.onScroll(o);

                // Recalculate the sidebar's position on every scroll and resize.
                $(document).scroll(
                    (function (o) {
                        return function () {
                            o.onScroll(o);
                        };
                    })(o)
                );
                $(window).resize(
                    (function (o) {
                        return function () {
                            o.stickySidebar.css({
                                position: "static",
                            });
                            o.onScroll(o);
                        };
                    })(o)
                );

                // Reset the sidebar to its default state
                function resetSidebar() {
                    o.fixedScrollTop = 0;
                    o.sidebar.css({
                        "min-height": "1px",
                    });
                    o.stickySidebar.css({
                        position: "static",
                        width: "",
                    });
                }

                // Get the height of a div as if its floated children were cleared. Note that this function fails if the floats are more than one level deep.
                function getClearedHeight(e) {
                    var height = e.height();

                    e.children().each(function () {
                        height = Math.max(height, $(this).height());
                    });

                    return height;
                }
            });
        }
    };
})(jQuery);

function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
}

window.debounce = debounce;
window.DataLayerEvent = DataLayerEvent;
const gTagLoader = new GTagLoader(storeContainerIds[window.storeId].gtm);
if (gTagLoader.checkCookieConsent()) {
    gTagLoader.loadGTag();
}

// window.dataLayer = window.dataLayer || [];
// window.isGtmLoaded = false;

// function onGtmReady(callback) {
//     let triggered = false;

//     function checkGtmEvent(entry) {
//         if (entry && entry.event === "gtm.js") {
//             if (!triggered) {
//                 triggered = true;
//                 callback();
//             }
//         }
//     }

//     // Check bestaande entries
//     window.dataLayer.forEach(checkGtmEvent);

//     // Wrap push om ook toekomstige entries te checken
//     const originalPush = window.dataLayer.push;
//     window.dataLayer.push = function () {
//         for (const arg of arguments) {
//             checkGtmEvent(arg);
//         }
//         return originalPush.apply(this, arguments);
//     };
// }
// window.loadGtag = function (measurementId) {
//     if (measurementId === false) {
//         return;
//     }
//     if (!window.gtag) {
//         window.dataLayer = window.dataLayer || [];
//         window.gtag = function () {
//             window.dataLayer.push(arguments);
//         };

//         const script = document.createElement("script");
//         script.async = true;
//         script.src =
//             "https://www.googletagmanager.com/gtag/js?id=" + measurementId;
//         document.head.appendChild(script);

//         gtag("js", new Date());
//         gtag("config", measurementId);
//     }
// };
// window.loadGTM = function (containerId) {
//     if (containerId === false) {
//         return;
//     }

//     (function (w, d, s, l, i) {
//         w[l] = w[l] || [];
//         w[l].push({
//             "gtm.start": new Date().getTime(),
//             event: "gtm.js",
//         });
//         var f = d.getElementsByTagName(s)[0],
//             j = d.createElement(s),
//             dl = l != "dataLayer" ? "&l=" + l : "";
//         j.async = true;
//         j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
//         f.parentNode.insertBefore(j, f);
//     })(window, document, "script", "dataLayer", containerId);
// };

// window.loadTikTok = function (containerId) {
//     if (containerId === false) {
//         return;
//     }
//     !(function (w, d, t) {
//         w.TiktokAnalyticsObject = t;
//         var ttq = (w[t] = w[t] || []);
//         (ttq.methods = [
//             "page",
//             "track",
//             "identify",
//             "instances",
//             "debug",
//             "on",
//             "off",
//             "once",
//             "ready",
//             "alias",
//             "group",
//             "enableCookie",
//             "disableCookie",
//         ]),
//             (ttq.setAndDefer = function (t, e) {
//                 t[e] = function () {
//                     t.push(
//                         [e].concat(Array.prototype.slice.call(arguments, 0))
//                     );
//                 };
//             });
//         for (var i = 0; i < ttq.methods.length; i++)
//             ttq.setAndDefer(ttq, ttq.methods[i]);
//         (ttq.instance = function (t) {
//             for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
//                 ttq.setAndDefer(e, ttq.methods[n]);
//             return e;
//         }),
//             (ttq.load = function (e, n) {
//                 var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
//                 (ttq._i = ttq._i || {}),
//                     (ttq._i[e] = []),
//                     (ttq._i[e]._u = i),
//                     (ttq._t = ttq._t || {}),
//                     (ttq._t[e] = +new Date()),
//                     (ttq._o = ttq._o || {}),
//                     (ttq._o[e] = n || {});
//                 n = document.createElement("script");
//                 (n.type = "text/javascript"),
//                     (n.async = !0),
//                     (n.src = i + "?sdkid=" + e + "&lib=" + t);
//                 e = document.getElementsByTagName("script")[0];
//                 e.parentNode.insertBefore(n, e);
//             });

//         ttq.load(containerId);
//         ttq.page();
//     })(window, document, "ttq");

//     window.isTikTokLoaded = true;
// };

// // Load GTM and TikTok
// // Check if the user has given consent for cookies
// window.checkCookieConsent = function (consentValue) {
//     if (
//         !consentValue &&
//         (window.getCookie("__cookie_consent") === "true" ||
//             window.getCookie("__cookie_consent") === 1 ||
//             window.getCookie("__cookie_consent") === 2)
//     ) {
//         return true;
//     }
//     if (consentValue === "true" || consentValue === 1 || consentValue === 2) {
//         return true;
//     }
//     return false;
// };

// window.getConsentData = function (initial) {
//     const cookieValue = window.getCookie("__cookie_consent");
//     let consentData = [
//         "consent",
//         "default",
//         {
//             ad_storage: "denied",
//             analytics_storage: "denied",
//             functionality_storage: "granted",
//             personalization_storage: "denied",
//             security_storage: "granted",
//         },
//     ];

//     if (initial === "default") {
//         window.log("Initial consent data:", consentData);
//         return consentData;
//     } else {
//         consentData[1] = "update";
//     }

//     consentData.ad_storage =
//         cookieValue === "true" || cookieValue === 2 ? "granted" : "denied";
//     consentData.analytics_storage =
//         cookieValue === "true" || cookieValue === 2 ? "granted" : "denied";
//     consentData.functionality_storage =
//         cookieValue === "true" || cookieValue === 1 || cookieValue === 2
//             ? "granted"
//             : "denied";
//     consentData.personalization_storage =
//         cookieValue === "true" || cookieValue === 1 || cookieValue === 2
//             ? "granted"
//             : "denied";
//     window.log("Updated consent data:", consentData);
//     return consentData;
// };

// window.initialConsent = window.checkCookieConsent();

// onGtmReady(() => {
//     window.isGtmLoaded = true;
//     window.log("GTM is geladen");
//     let consentData = window.getConsentData("default");
//     window.gtag(consentData[0], consentData[1], consentData[2]);
//     if (window.checkCookieConsent()) {
//         window.log("Consent is gegeven", window.getConsentData());
//         let consentData = window.getConsentData();
//         window.gtag(consentData[0], consentData[1], consentData[2]);
//     }
// });

// if (window.checkCookieConsent()) {
//     window.log("Consent is gegeven");
//     window.loadGtag(storeContainerIds[window.storeId].gtm);
//     window.loadTikTok(storeContainerIds[window.storeId].tiktok);
// }

// window.cookieBannerConsentChange((consent) => {
//     window.log("Consent is gewijzigd:", consent);
//     window.log("isGtmLoaded:", isGtmLoaded);
//     if (window.checkCookieConsent(consent) && !isGtmLoaded) {
//         window.loadGtag(storeContainerIds[window.storeId].gtm);
//         window.loadTikTok(storeContainerIds[window.storeId].tiktok);
//     }
//     if (window.checkCookieConsent(consent) && isGtmLoaded) {
//         window.log("Consent data:", window.getConsentData());
//         let consentData = window.getConsentData();
//         window.gtag(consentData[0], consentData[1], consentData[2]);
//     }
//     // Doe hier iets met de nieuwe consent-status
// });
